import { useMemo } from 'react';
import queryString from 'query-string';

import { useRecaptcha } from '../../../hooks/useRecaptcha';
import { useRecaptchaChallengeObserver } from '../../../utilities/hooks';
import { useLoginState } from '../../../utilities/hooks/useLoginState';
import { pageId } from '../constants';
import { LoginGlobalError, URLParameters } from '../../../types';
import { isCheckUsernameRecaptchaEnabledFF } from '../../../utilities/recaptcha';

export const useLoginRecaptcha = () => {
  useRecaptchaChallengeObserver(pageId);
  const { state } = useLoginState();

  const queryParams: URLParameters = queryString.parse(location.search);

  const errorCode = useMemo(
    () => (queryParams.errorCode ? ({ code: queryParams.errorCode } as LoginGlobalError) : null),
    [queryParams.errorCode]
  );

  const error = state?.login?.error || errorCode;
  const recaptchaType = error?.code === 'captchaScoreTooLow' ? 'checkbox' : 'score';

  const isCheckUsernameRecaptchaEnabled = isCheckUsernameRecaptchaEnabledFF();

  const recaptcha = useRecaptcha({
    pageId,
    type: recaptchaType,
    enabledProp: isCheckUsernameRecaptchaEnabled,
    action: 'checkUsername',
  });

  return { recaptcha, recaptchaType };
};
